import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { Splitter } from 'antd';
import React from 'react';
import { useInspectedTracker } from '../../../lib/customHooks';
import { MiniMap } from '../../BasicComponents/Maps';
import { PointLayer } from '../../BasicComponents/Maps/Layers';
import { dresdenViewport } from '../../BasicComponents/Maps/mocks';
import { IconFail } from '../../Icon';
import { Column } from './Column';
import { TopBar } from './TopBar';
import { TrackerInfos } from './TrackerInfos';

interface Props {
  onCloseClick: () => void;
}

export const MapAndInfosColumn = React.memo(function MapAndInfosColumn({ onCloseClick }: Props) {
  const inspectedTracker = useInspectedTracker();
  const lastGeo = inspectedTracker?.lastGeo;
  const point = lastGeo?.lng != null && lastGeo?.lat != null ? [lastGeo.lng, lastGeo.lat] : null;

  return (
    <Column
      topBarContent={
        <Bar>
          <Title>
            Tracker: <TrackerName>{inspectedTracker?.trackerName}</TrackerName>
          </Title>
          <IconFail onClick={onCloseClick} />
        </Bar>
      }
    >
      <Splitter layout="vertical">
        <Splitter.Panel defaultSize="35%" min="13%">
          <MiniMap
            defaultViewState={dresdenViewport}
            controls={{ navigation: true, fitToViewport: true }}
          >
            <PointLayer
              autofocus
              points={point}
              color={RacemapColors.PaleBlue}
              radius={5}
              lineWidth={3}
              fillColor="white"
            />
          </MiniMap>
        </Splitter.Panel>
        <Splitter.Panel defaultSize="65%" min="13%">
          <TrackerInfos />
        </Splitter.Panel>
      </Splitter>
    </Column>
  );
});

const Bar = styled(TopBar)`
  justify-content: space-between;
`;

const TrackerName = styled.div`
  font-weight: 600;
  color: black;
  margin-left: 5px;
`;

const Title = styled.div`
  color: ${RacemapColors.DarkGray};
  display: flex;
`;
